/**
 * Read More Functionality
 * Handles expandable collection descriptions
 */

class ReadMoreHandler {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Find all read more buttons
    const readMoreButtons = document.querySelectorAll('[data-toggle="readMore"]');

    readMoreButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleReadMore(e));
    });

    // Set initial states
    this.setInitialStates();
  }

  setInitialStates() {
    // Ensure all expandable content is initially hidden
    const expandableContent = document.querySelectorAll('[id^="moreText-"]');

    expandableContent.forEach(content => {
      content.style.display = 'none';
      content.setAttribute('aria-hidden', 'true');
    });
  }

  handleReadMore(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const targetId = button.getAttribute('data-target');
    const targetContent = document.getElementById(targetId);

    if (!targetContent) {
      console.warn(`Target element with ID "${targetId}" not found`);
      return;
    }

    const isExpanded = targetContent.style.display !== 'none';

    if (isExpanded) {
      this.collapseContent(targetContent, button);
    } else {
      this.expandContent(targetContent, button);
    }
  }

  expandContent(content, button) {
    // Show content with smooth animation
    content.style.display = 'block';
    content.setAttribute('aria-hidden', 'false');

    // Set initial state for animation
    content.style.opacity = '0';
    content.style.maxHeight = '0';
    content.style.overflow = 'hidden';
    content.style.transition = 'all 0.3s ease-out';

    // Force reflow
    content.offsetHeight;

    // Animate to visible state
    requestAnimationFrame(() => {
      content.style.opacity = '1';
      content.style.maxHeight = content.scrollHeight + 'px';
    });

    // Clean up after animation
    setTimeout(() => {
      content.style.maxHeight = 'none';
      content.style.overflow = 'visible';
    }, 300);

    // Update button
    button.textContent = 'Read less...';
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('read-more--expanded');
  }

  collapseContent(content, button) {
    // Prepare for animation
    content.style.maxHeight = content.scrollHeight + 'px';
    content.style.overflow = 'hidden';
    content.style.transition = 'all 0.3s ease-out';

    // Force reflow
    content.offsetHeight;

    // Animate to collapsed state
    requestAnimationFrame(() => {
      content.style.opacity = '0';
      content.style.maxHeight = '0';
    });

    // Hide after animation
    setTimeout(() => {
      content.style.display = 'none';
      content.setAttribute('aria-hidden', 'true');
      content.style.maxHeight = '';
      content.style.overflow = '';
      content.style.transition = '';
      content.style.opacity = '';
    }, 300);

    // Update button
    button.textContent = 'Read more...';
    button.setAttribute('aria-expanded', 'false');
    button.classList.remove('read-more--expanded');
  }

  // Public method to manually trigger read more
  static trigger(targetId) {
    const button = document.querySelector(`[data-target="${targetId}"]`);
    if (button) {
      button.click();
    }
  }
}

// Initialize when script loads
const readMoreHandler = new ReadMoreHandler();

// Export for potential external use
window.ReadMoreHandler = ReadMoreHandler;